import { useEffect, useState } from "react";
import "./header.css";
import { useNavigate } from "react-router-dom";
import api from '../api/axios';

const Header = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleLogin = () => {
    api.post('/api/v1/login', JSON.stringify({ login: login, password: password }), {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if(response.data.auth)
      {
        if(response.data.auth.success == true)
        {
          localStorage.setItem('token', response.data.auth.token);
          setShowModal(false);
          setIsAuth(true);
          setLogin("");
          setPassword("");

          navigate('/profile');
        }
      }
    })
    .catch(error => {
      console.error('Помилка входу:', error);
    });
  };

  useEffect(() => {
    // Проверка, есть ли токен в localStorage
    if (localStorage.getItem("token")) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  }, []);

  return (
    <header className="header">
      <div className="logo">
        <span>AutoInfo</span>
      </div>
      <nav className="nav-links">
        <a onClick={() => navigate("/")}>Головна</a>
        <a onClick={() => navigate("/catalog")}>Каталог</a>
        <a onClick={() => navigate("/reviews")}>Відгуки</a>
        <a onClick={() => navigate("/news")}>Новини</a>
        <a>Статті</a>
        <a onClick={() => navigate("/contact")}>Контакти</a>
      </nav>
      <div className="auth-buttons">
        {!isAuth ? (
          <>
            <button className="login-btn" onClick={toggleModal}>
              Увійти
            </button>
            <button className="register-btn">Зареєструватися</button>
          </>
        ) : (
          <button className="login-btn" onClick={() => navigate("/profile")}>Профіль</button>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={toggleModal}>
              ×
            </span>
            <h2>Вхід до системи</h2>
            <input type="text" placeholder="Логін" onChange={(e) => setLogin(e.target.value)} />
            <input type="password" placeholder="Пароль" onChange={(e) => setPassword(e.target.value)} />
            <button className="submit-btn" onClick={handleLogin}>Увійти</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
